module.exports = __webpack_public_path__ + "static/media/brand-refresh-fb-icon.e38b9972.svg";